import type { ComponentProps } from "react"
import { useEffect } from "react"
import { useFormState } from "react-hook-form"
import { Spinner } from "@/ui/components/ui/spinner"
import { Button } from "@/ui/components/ui/button"

type Props = Pick<
  ComponentProps<typeof Button>,
  "children" | "disabled" | "className" | "variant"
> & {
  disabledUntilDirty?: boolean
  onDirtyChange?: (isDirty: boolean) => void
}

export default function FormSubmitButton({
  children,
  disabledUntilDirty = true,
  disabled,
  onDirtyChange,
  ...props
}: Props) {
  const { isSubmitting, isDirty } = useFormState()

  useEffect(() => {
    onDirtyChange?.(isDirty)
  }, [isDirty, onDirtyChange])

  return (
    <Button
      type="submit"
      {...props}
      disabled={!!disabled || isSubmitting || (!isDirty && disabledUntilDirty)}
    >
      {isSubmitting && <Spinner />}
      {children}
    </Button>
  )
}
